/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerScheduledPaymentsResponse as ModelsCustomerCustomerScheduledPaymentsResponse } from '../../models/Models/Customer/customer-scheduled-payments-response';

export interface V4CustomersMeAccountsAccountNumberPaymentsGet$Json$Params {
  accountNumber: string;
  dateFrom?: string;
  dateTo?: string;
}

export function v4CustomersMeAccountsAccountNumberPaymentsGet$Json(http: HttpClient, rootUrl: string, params: V4CustomersMeAccountsAccountNumberPaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeAccountsAccountNumberPaymentsGet$Json.PATH, 'get');
  if (params) {
    rb.path('accountNumber', params.accountNumber, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>;
    })
  );
}

v4CustomersMeAccountsAccountNumberPaymentsGet$Json.PATH = '/v4/customers/me/accounts/{accountNumber}/payments';
